import React from 'react'
import PropTypes from 'prop-types'

import auctionIcon from './assets/auction.svg'
import eoiIcon from './assets/eoi.svg'
import privateTreatyIcon from './assets/private-treaty.svg'

import styles from './styles.scss'

const auctionText = () => (
  <span>
    In the right market conditions an Auction sale provides highly competitive and emotionally driven buying that will
    push the final sale price higher. With the right amount of interest and a good number of buyers on Auction day
    you&apos;ll be amazed with the results you can achieve.
  </span>
)

const expressionsText = () => (
  <span>
    For more private sellers with properties that are harder to price an expressions of interest sale will reveal the
    true value of your property and then allow us to pitch multiple interested parties against one another to achieve
    the top possible sale price.
  </span>
)

const privateTreatyText = () => (
  <span>
    A Private Treaty sale gives both the buyers and sellers time to make well considered and educated decisions
    about the property sale. We will be able to play multiple offers against each other and increase the sale price as
    much as the market will allow.
  </span>
)

const saleMethodIcons = {
  Auction: auctionIcon,
  'Expressions of Interest': eoiIcon,
  'Private Treaty': privateTreatyIcon,
}

const renderSaleMethodDescription = ({ title }) => {
  if (title === 'Auction') return auctionText()
  if (title === 'Expressions of Interest') return expressionsText()
  if (title === 'Private Treaty') return privateTreatyText()
  return null
}

const renderSaleMethodDetail = (campaignSaleMethod) => {
  const description = renderSaleMethodDescription(campaignSaleMethod)

  if (description){
    return (
      <div className={styles.saleMethod}>
        <span className={styles.iconHolder}>
          <img alt="Icon" src={saleMethodIcons[campaignSaleMethod.title]} />
        </span>

        <div className={styles.text}>
          <span className={styles.title}>{campaignSaleMethod.title}</span>
          <span className={styles.description}>{description}</span>
        </div>
      </div>
    )
  }

  return null
}

const SaleMethod = (props) => {
  const { campaignSaleMethod } = props

  if (!campaignSaleMethod || !campaignSaleMethod.title) return null

  return (
    <div className={styles.root}>
      <h4>Method of Sale</h4>
      <span className={styles.intro}>
        In your area and with the current market situation we believe that selling via{' '}
        <strong>{campaignSaleMethod.title}</strong> will produce the best possible results for your property.
      </span>
      {renderSaleMethodDetail(campaignSaleMethod)}
    </div>
  )
}

SaleMethod.propTypes = {
  campaignSaleMethod: PropTypes.object.isRequired,
}

export default SaleMethod
